// import { reducers, actions } from "../redux";

const notHasModeViewAs = viewAs => !viewAs;
export default notHasModeViewAs;
